export type ImportRow<T extends object> =
  | {
      number: number
      status: "new"
      oldInstance: null
      patch: T
    }
  | {
      number: number
      status: "update"
      oldInstance: T
      patch: Partial<T>
    }
  | {
      number: number
      status: "unchanged"
      oldInstance: T
      patch: Record<string, never>
    }
  | {
      number: number
      status: "delete"
      oldInstance: T
      patch: null
    }

export type RowError = {
  number: number
  data: object
  errors: {
    msg: string
    loc: string[]
    type: string
  }[]
}

export type ImportResponse<ObjectT extends object> =
  | {
      id: string
      data: {
        rows: ImportRow<ObjectT>[]
        rowErrors?: RowError[]
      }
      status: "dr_finished" | "pending" | "started"

      createdAt: Date
      rowErrors?: boolean
      importedAt: null
    }
  | {
      id: string
      data: {
        rows: ImportRow<ObjectT>[]
      }
      status: "finished"
      createdAt: Date
      rowErrors?: boolean
      importedAt: Date
    }
  | {
      id: string
      data: null
      status: "dr_pending" | "dr_started"
      createdAt: Date
      rowErrors?: boolean
      importedAt: null
    }

type ImportResponseRaw<T extends object> =
  RecursivelyConvertDatesToStrings<ImportResponse<T>>

export const parseImportResponse = <T extends object>(
  importResponse: ImportResponseRaw<T>
): ImportResponse<T> =>
  ({
    ...importResponse,
    createdAt: DateFns.parseISO(importResponse.createdAt),
    importedAt: importResponse.importedAt
      ? DateFns.parseISO(importResponse.importedAt)
      : null,
  }) as ImportResponse<T>
